import { useCurrentStateAndParams } from '@uirouter/react';
import { useState, useEffect } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import { pageStateAtom } from '../provider_edit_atoms';
import { pageStateVM } from '../provider_edit_view_models';
import { PageInit } from '../provider_edit_types';

export const useProviderEditInit = (): PageInit => {
    const [title, setTitle] = useState('Edit Provider');
    const setState = useSetImmerAtom(pageStateAtom);
    const route = useCurrentStateAndParams();

    // INIT
    useEffect(() => {
        setState(draft => {
            if (draft.init) {
                // get context from Angular
                draft.canEdit = true;

                // get mode / title / params from route
                draft.mode = 'UPDATE';
                draft.id = draft.mode == 'UPDATE' && !!route.params ? route.params.Id : '';

                // everything is settled off route
                draft.init = false;
                return draft;
            } else {
                return draft;
            }
        });

        // destroy
        return (): void => {
            setState(() => pageStateVM());
        };
    }, [route, setState, setTitle]);

    return title;
};
